import CroustilleElement from "../lib/CroustilleElement";
import requestInterval, { clearRequestInterval } from "../lib/requestInterval";

const SIZES = {
  CLOSE: "(min-width: 768px) 50vw, 100vw",
  OPEN: "(min-width: 768px) 75vw, 100vw",
};

class ImageContainer extends CroustilleElement {
  constructor() {
    super("image-container");
  }

  spy() {
    const elementsInMiddleOfScreen = document.elementsFromPoint(
      window.innerWidth / 2,
      window.innerHeight / 2
    );

    this.images.forEach((image) => {
      elementsInMiddleOfScreen.forEach(($elAtPoint) => {
        if ($elAtPoint === image) {
          const counter = this.child("counter", document);
          counter &&
            (counter.innerHTML = `${image.dataset.index} / ${this.count}`);
        }
      });
    });
  }

  reflow() {
    const counter = this.child("counter", document);

    if (counter) {
      counter.classList.remove("animate");
      // void va provoquer un 'redraw' de l'élément et relancer l'animation
      // eslint-disable-next-line
      void counter.offsetWidth;
      counter.classList.add("animate");
    }
  }

  containerOpen() {
    this.reflow();
    setTimeout(this.updateImageSizesAttr(SIZES.OPEN), 550);
  }

  containerClose() {
    this.reflow();
    setTimeout(this.updateImageSizesAttr(SIZES.CLOSE), 500);
  }

  updateImageSizesAttr(attr) {
    const elements = this.node.querySelectorAll(`source[sizes]`);
    elements.forEach((e) => (e.sizes = attr));
  }

  init() {
    this.images = this.children("image");
    this.count = this.images.length || 0;
    this._containerClose = this.containerClose.bind(this);
    this._containerOpen = this.containerOpen.bind(this);

    this.style.display = "block";

    this.images.forEach((image, index) => (image.dataset.index = index + 1));

    this.fM = requestInterval(this.spy.bind(this), 360);
    document.addEventListener("threesides:open", this._containerOpen);
    document.addEventListener("threesides:close", this._containerClose);
  }

  destroy() {
    if (this.fM) {
      clearRequestInterval(this.fM);
    }
    document.removeEventListener("threesides:open", this._reflow);
    document.removeEventListener("threesides:close", this._reflow);
  }
}

export default ImageContainer;
